import { z } from "zod"

import { PriceChangeType } from "@/graphql/codegen/graphql"

export const PriceChangeFilterFormSchema = z
  .object({
    changeType: z
      .nativeEnum(PriceChangeType)
      .nullable()
      .refine((value): boolean => value?.trim() !== "" && value !== null, { message: "Change Type is required" }),
    productManagerId: z.string().nullish(),
    supplierId: z.string().nullish(),
    customerIds: z.array(z.string()).optional(),
    productCategoryId: z.string().nullish(),
    productClassId: z.string().nullish(),
    specificProductIds: z.array(z.string()).optional(),
    shipFromId: z.string().nullish(),
    shipToId: z.string().nullish(),
    effectiveDate: z.string().nullish(),
  })
  .superRefine((values, ctx) => {
    if (
      values.changeType === PriceChangeType.SellingPrice &&
      (values.productManagerId?.trim() === "" || !values.productManagerId)
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Product manager is required",
        path: ["productManagerId"],
      })
    }
  })

export type PriceChangeFilterFormValues = z.infer<typeof PriceChangeFilterFormSchema>
